import { useListContext, useTranslate } from 'react-admin'

/** A sidebar choice filter: what <ChoiceFilter> is given. */
export interface ChoiceFilterDefinition {
  source: string
  label: string
  choices: { id: string; name: string }[]
}

/**
 * The sidebar choices in effect, readable ("Status: in Bearbeitung"), and a way
 * to lift them. A list remembers its filters, also across reloads, and a
 * highlighted choice in the sidebar is easy to miss — a search then finds
 * nothing outside it, which looks like a broken search.
 */
export const useActiveChoiceFilters = (definitions: ChoiceFilterDefinition[]) => {
  const { filterValues, setFilters, displayedFilters } = useListContext()
  const translate = useTranslate()
  const active = definitions
    .filter((d) => filterValues?.[d.source] != null && filterValues[d.source] !== '')
    .map((d) => {
      const value = filterValues[d.source]
      const choice = d.choices.find((c) => c.id === value)
      return {
        source: d.source,
        label: translate(d.label),
        value: choice ? translate(choice.name) : String(value),
      }
    })
  /** Lifts the given choice filters (all of them by default); a search stays. */
  const clear = (sources: string[] = active.map((a) => a.source)) => {
    const next = { ...filterValues }
    for (const source of sources) delete next[source]
    setFilters(next, displayedFilters)
  }
  return { active, clear }
}
